import React from 'react'
import { FormSelect } from 'shards-react'
import PropTypes from 'prop-types'

const BaseSelect = ({ name, options, className, targetValue, onchange, showerror }) => {
    return (
        <FormSelect onChange={onchange} name={name} className={className} value={targetValue} invalid={showerror}>
            {options &&
                options.map((opt, idx) => (
                    <option key={`${opt.name}_${idx}`} value={opt.value} disabled={opt.disabled}>
                        {opt.name}
                    </option>
                ))}
        </FormSelect>
    )
}
BaseSelect.propTypes = {
    options: PropTypes.array,
    onchange: PropTypes.func,
    name: PropTypes.string,
    className: PropTypes.string,
    targetValue: PropTypes.string,
    showerror: PropTypes.bool,
}

export default BaseSelect
